import {Component, OnInit} from '@angular/core';
import {SettingsService} from '../../../core/settings/settings.service';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { RmsService } from "../../../../../projects/jv-common/src/public_api";
import {Router} from "@angular/router";
import {createDecipher} from 'crypto';

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  valForm: FormGroup;

  error = false;


  loading = false;

  constructor(public settings: SettingsService,
    fb: FormBuilder,
    private rms: RmsService,
    private router: Router
  ) {

    this.valForm = fb.group({
      'username': [null, Validators.required],
      'password': [null, Validators.required]
    });

  }

  submitForm($ev, value: any) {
    $ev.preventDefault();
    $('#login-sub').attr('disabled', 'disabled');
    for (let c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {
      this.rms.login(value.username, value.password).subscribe(result => {
        localStorage.setItem('debug', 'false');
        if (result) {
          this.rms.pomDataUser().subscribe(rs => {
            if (rs.succeed){
              this.rms.setUser(rs.data);
              this.router.navigateByUrl('/');
            }else{
              this.error = true;
            }
          });
        } else {
          this.error = true;
        }
        $('#login-sub').removeAttr('disabled');
      });
    }
  }

  ngOnInit() {

  }

  onBlurMethod() {
  }
}
